// extracted by css-extract-rspack-plugin
export default {"component":"Chart-module__component___Jmp2_"};